import {GraphQLClient} from 'graphql-request';
import {WEDDING_WEBSITE_GRAPHQL_ENDPOINT} from '../../constants/app';

const weddingWebsiteGraphQLClient = new GraphQLClient(
  WEDDING_WEBSITE_GRAPHQL_ENDPOINT,
);

export default weddingWebsiteGraphQLClient;
